import {
    format,
    startOfWeek, 
    endOfWeek, 
    isSameMonth, 
    isSameYear,
    addMonths,
} from 'date-fns';

import { third_party_constants } from 'constants/third_party_constants';

/* Takes in a date (string) and a view (string) and returns a formatted string for display on Calendars
 *
 * @param {string} date - Date Object in string form, to be formatted
 * @param {string} view - the current view, one of [ "month", "week", "day", "agenda" ]
 * @return a formatted string representation of the Dates currently shown in the Calendar view
 */
export const formatCalendarDate = (date, view) => {
    const newDate = new Date(date);
    switch (view) {
        case 'month':
            return format(newDate, 'MMMM yyyy');
        case 'week':
            const weekStart = startOfWeek(newDate);
            const weekEnd = endOfWeek(newDate);

            // same year, same month
            if (isSameMonth(weekStart, weekEnd)) {
                return `${format(weekStart, 'MMMM d')} - ${format(weekEnd, 'd, yyyy')}`;
            }
            // same year, different month
            if (isSameYear(weekStart, weekEnd)) {
                return `${format(weekStart, 'MMM d')} - ${format(weekEnd, 'MMM d, yyyy')}`;
            }
            // different year, different month
            return `${format(weekStart, 'MMM d, yyyy')} - ${format(weekEnd, 'MMM d, yyyy')}`;
        case 'day':
            return format(newDate, 'eee MMMM d, yyyy');
        case 'agenda':
            const endDate = addMonths(newDate, 1);
            // same year, same month
            if (isSameMonth(newDate, endDate)) {
                return `${format(newDate, 'MMMM d')} - ${format(endDate, 'd, yyyy')}`;
            }
            // same year, different month
            if (isSameYear(newDate, endDate)) {
                return `${format(newDate, 'MMM d')} - ${format(endDate, 'MMM d, yyyy')}`;
            }
            // different year, different month
            return `${format(newDate, 'MMM d, yyyy')} - ${format(endDate, 'MMM d, yyyy')}`;
        default:
            return;
    }
};

export const parseLocation = (location) => {
    if (!location) return third_party_constants.in_person();

    if (location.includes("zoom.us")) {
        return third_party_constants.zoom;
    }

    if (location.includes("meet.google.com")) {
        return third_party_constants.google_meet;
    }

    if (location.includes ("teams.microsoft.com")) {
        return third_party_constants.microsoft_teams;
    }

    if (location.includes("google")) {
        return third_party_constants.google;
    }

    return third_party_constants.in_person();
};
